import React, { useEffect, useState } from "react";
import { useResponsive } from "../../utils/use-responsive";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  InputNumber,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import cashOutline from "../../assets/images/cash-outline.svg";
import styles from "./customer-card.module.scss";

const { Title, Text } = Typography;
const { Option } = Select;

export const DrawDownFunds: React.FC<any> = ({ modalState }) => {
  const { isTablet, isMobile, isXs } = useResponsive();

  const prefixSelector = (
    <Form.Item name="prefix" noStyle>
      EUR
    </Form.Item>
  );
  function showOptionalOrIcon() {
    if (!isXs) {
      return (
        <div className={styles["cardIcon"]}>
          <img alt="Icon" src={cashOutline} style={{ width: "30px" }} />
        </div>
      );
    }
  }
  return (
    <>
      <Alert
        message="Funds will arrive within 48 hours."
        type="warning"
        style={{ borderRadius: "8px" }}
      />
      <Card style={{ marginTop: "20px", padding: "20px" }}>
        <Space
          direction={"horizontal"}
          size={"small"}
          className={"ant-row-space-between"}
        >
          {showOptionalOrIcon()}

          <Space.Compact direction={"vertical"} className={"full-width"}>
            <Space
              direction={"horizontal"}
              size={"small"}
              className={"ant-row-space-between"}
            >
              <Space direction={"horizontal"} size={"small"}>
                <Text type="secondary" style={{ margin: 0, color: "#08152C" }}>
                  Funding remaining
                </Text>
              </Space>
              {isXs && (
                <img alt="Icon" src={cashOutline} style={{ width: "30px" }} />
              )}
            </Space>
            <Title level={2} style={{ margin: 0, fontWeight: "lighter" }}>
              €100,000 /{" "}
              <span style={{ fontSize: "20px", fontWeight: "lighter" }}>
                €241,250
              </span>
            </Title>
          </Space.Compact>
        </Space>
      </Card>

      <Form style={{ marginTop: isMobile ? "20px" : "50px" }}>
        <Space direction={"vertical"}>
          <Text type="secondary" style={{ margin: 0 }}>
            How much do you want to draw down?
          </Text>
          <Form.Item
            rules={[{ required: true, message: "Required! " }]}
            style={{ marginBottom: 0 }}
            name={"funds"}
          >
            <InputNumber
              addonBefore={prefixSelector}
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Text type="secondary" style={{ margin: 0 }}>
            Thank you for completing the application. At the moment, 
            our minimum funding amount is €50,000. If this was an 
            input error please restart the application however if 
            correct it appears it might be too soon for Financefair 
            to support. If your needs change or you'd like to 
            explore future options, please do not hesitate to get 
            back in touch.
          </Text>
        </Space>
        <Row style={{ marginTop: isMobile ? "20px" : "50px" }} gutter={[8, 8]}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} span={12}>
            <Button
              onClick={() => modalState(false)}
              className="cancelDrawFunds"
              type="primary"
              block
              size="large"
            >
              Cancel
            </Button>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} span={12}>
            <Button
              className="confirmDrawFunds"
              block
              type="primary"
              size="large"
              onClick={() => modalState(false)}
            >
              Confirm
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};
